const triggerExcludes = (excludeParam) => {
  return typeof excludeParam !== 'undefined' && excludeParam === 'true';
};

export default triggerExcludes;
